import { Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'

export const BreadcrumbCreator = (props: { items: Array<{ title: string; location?: string }> }) => {
  return (
    <Breadcrumb className='main-breadcrumb' separator='/'>
      {props.items.map(({ title, location }) => {
        return <Breadcrumb.Item key={title}>{location ? <Link to={location}>{title}</Link> : title}</Breadcrumb.Item>
      })}
    </Breadcrumb>
  )
}
